import type {SVGProps} from 'react'
const SvgFlag = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    id="flag_svg__Layer_1"
    x={0}
    y={0}
    viewBox="0 0 512 512"
    {...props}
  >
    <style>{'.flag_svg__st0{fill:tomato}'}</style>
    <path
      d="M495.8 331.1c0 6.6-4 12.5-10.2 14.9-38 14.8-72.7 22-106.2 22-34.8 0-65.6-7.8-95.4-15.4-33.1-8.5-64.3-16.4-103.2-16.4-68.6 0-130.5 28.8-150.8 38.2l-14 6.3V62.6l22-8.9c85.1-34.5 120.6-37.3 147.2-37.3 33.2 0 57.4 7.8 83.1 16 24.3 7.8 49.3 15.9 80.8 15.9 34.2 0 70.6-9.3 114.5-29.4 3.9-1.8 8.5-2.8 12.8-2.8 5 0 9.5 1.3 13.9 3.9 3.4 2.1 5.7 7 5.7 12.4z"
      className="flag_svg__st0"
    />
    <path
      d="M495.8 331.1c0 6.6-4 12.5-10.2 14.9-38 14.8-72.7 22-106.2 22-34.8 0-65.6-7.8-95.4-15.4-33.1-8.5-64.3-16.4-103.2-16.4-68.6 0-130.5 28.8-150.8 38.2l-14 6.3V62.6l22-8.9c85.1-34.5 120.6-37.3 147.2-37.3 33.2 0 57.4 7.8 83.1 16 24.3 7.8 49.3 15.9 80.8 15.9 34.2 0 70.6-9.3 114.5-29.4 3.9-1.8 8.5-2.8 12.8-2.8 5 0 9.5 1.3 13.9 3.9 3.4 2.1 5.7 7 5.7 12.4z"
      className="flag_svg__st0"
    />
    <path
      d="M498.5 6.2C491.7 2.1 484.2 0 476.3 0 469.7 0 463 1.5 457 4.2c-41.8 19.1-76 27.9-107.8 27.9-29 0-51.8-7.3-75.9-15.1C247.5 8.8 220.1.2 185.2.2c-28.1 0-65.5 3-153.2 38.5l-16 6.5V8c0-4.4-3.6-8-8-8S0 3.6 0 8v496c0 4.4 3.6 8 8 8s8-3.6 8-8V398.2l20.7-9.3c19.6-9.1 79.1-36.8 144.2-36.8 36.8 0 67.1 7.7 99.2 15.9 30.7 7.8 62.5 15.9 99.3 15.9 35.5 0 72.1-7.5 111.1-23.1 12.4-4.8 20.4-16.5 20.4-29.8L512 32.3c0-11-5.2-21-13.5-26.1m-2.7 324.9c0 6.6-4 12.5-10.2 14.9-38 14.8-72.7 22-106.2 22-34.8 0-65.6-7.8-95.4-15.4-33.1-8.5-64.3-16.4-103.2-16.4-68.6 0-130.5 28.8-150.8 38.2l-14 6.3V62.6l22-8.9c85.1-34.5 120.6-37.3 147.2-37.3 33.2 0 57.4 7.8 83.1 16 24.3 7.8 49.3 15.9 80.8 15.9 34.2 0 70.6-9.3 114.5-29.4 3.9-1.8 8.5-2.8 12.8-2.8 5 0 9.5 1.3 13.9 3.9 3.4 2.1 5.7 7 5.7 12.4z"
      style={{
        fill: '#333',
      }}
    />
  </svg>
)
export default SvgFlag
